module.exports = __webpack_public_path__ + "img/1688.023bd0b0.jpg";